import React from "react";

const InfoTooltip = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M18 2c8.837 0 16 7.163 16 16s-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2Zm1.6 11.2V10h-3.2v3.2h3.2Zm0 12.8v-9.6h-3.2V26h3.2Z"
              fill={fill}/>
    </svg>
);

export default InfoTooltip;